<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('form_label_search') || '面料名称/花型/工艺/成分 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="800px"
      :close-on-click-modal="false"
      v-el-dialog-drag
    >
      <el-form ref="form" :model="form" size="mini">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item :label="$l('INDEX.Status') || '状态'">
              <dict-select
                v-model="form.resFabricDemandStatusList"
                url="/sys/common/dict/system"
                :body="resFabricDemandStatusParams"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                filterable
                clearable
                multiple
                size="mini"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_fabric_name') || '面料名称'">
              <el-input
                v-model.trim="form.fabricName"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_fabric_content') || '成分'">
              <el-input
                v-model="form.fabricContent"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_color_name') || '颜色'">
              <el-input
                v-model.trim="form.colorName"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_color_no') || '编号'">
              <el-input
                v-model="form.scmColorNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="12">
            <el-row>
              <el-form-item :label="$l('form_label_fabric_weight') || '克重'">
                <br />
                <el-col :span="8">
                  <el-input-number
                    controls-position="right"
                    style="width: 100%"
                    :min="0.01"
                    :step="0.01"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    v-model="form.fabricWeightStart"
                  ></el-input-number>
                </el-col>
                <el-col class="line" :span="1">-</el-col>
                <el-col :span="8">
                  <el-input-number
                    controls-position="right"
                    style="width: 100%"
                    :min="0.01"
                    :step="0.01"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    v-model="form.fabricWeightEnd"
                  ></el-input-number>
                </el-col>
                <el-col :span="6" :offset="1">
                  <el-form-item>
                    <dict-select
                      v-model="form.fabricWeightUnit"
                      url="/digitalCenter/common/dict/biz"
                      :body="{ dictType: 'fabricWeightUnit' }"
                      :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                      size="mini"
                      style="width: 100%"
                      filterable
                      clearable
                    ></dict-select>
                  </el-form-item>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-form-item :label="$l('form_label_wid') || '门幅'">
                <br />
                <el-col :span="8">
                  <el-input-number
                    controls-position="right"
                    style="width: 100%"
                    :min="0.01"
                    :step="0.01"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    v-model="form.widStart"
                  ></el-input-number>
                </el-col>
                <el-col class="line" :span="1">-</el-col>
                <el-col :span="8">
                  <el-input-number
                    controls-position="right"
                    style="width: 100%"
                    :min="0.01"
                    :step="0.01"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    v-model="form.widEnd"
                  ></el-input-number>
                </el-col>
                <el-col :span="6" :offset="1">
                  <el-form-item prop="widUnit">
                    <dict-select
                      v-model="form.widUnit"
                      url="/digitalCenter/common/dict/biz"
                      :body="{ dictType: 'widUnit' }"
                      :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                      style="width: 100%"
                      filterable
                      clearable
                      size="mini"
                    ></dict-select>
                  </el-form-item>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_fabric_factory') || '面料工厂'"
            >
              <dict-select
                v-model="form.listScmCode"
                url="/master/common/dict/allScmCooperated"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                clearable
                filterable
                multiple
                size="mini"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_fabric_demand_no') || '需求单号'"
            >
              <el-input
                v-model="form.resFabricDemandNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
                size="mini"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 
          <el-col :span="12">
            <el-form-item :label="$l('form_label_custName') || '客户'">
              <dict-select
                v-model="form.listCustCode"
                url="/master/common/dict/customerSelect"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                clearable
                filterable
                multiple
                size="mini"
              ></dict-select>
            </el-form-item>
          </el-col> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  resFabricDemandStatusList: ['T', 'P', 'Y'],
}
export default {
  data() {
    return {
      resFabricDemandStatusParams: { dictType: 'resFabricDemandStatus' },

      advqueryDialogVisible: false,
      form: { ...initForm },
    }
  },

  mounted() {
    this.query()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
